import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8bf4fe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar--main" }
const _hoisted_2 = {
  key: 0,
  class: "field has-addons header-field"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "control" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "button is-small is-static" }, "View")
], -1))
const _hoisted_4 = { class: "control" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "No view", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "control" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "field has-addons header-field"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "control" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "button is-small is-static" }, "Spread")
], -1))
const _hoisted_12 = { class: "control" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  select: "",
  value: null
}, "No spread", -1))
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "control" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "control" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-up" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "control" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-down" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "control" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "field has-addons header-field" }
const _hoisted_28 = { class: "control" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 0,
  class: "fas fa-play"
}
const _hoisted_31 = {
  key: 1,
  class: "fas fa-spinner"
}
const _hoisted_32 = { class: "control" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 0,
  class: "fas fa-play-circle"
}
const _hoisted_35 = {
  key: 1,
  class: "fas fa-stop-circle"
}
const _hoisted_36 = { class: "control" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  select: "",
  value: null
}, "No preview argument", -1))
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "control" }
const _hoisted_40 = ["value"]
const _hoisted_41 = { class: "field has-addons header-field" }
const _hoisted_42 = { class: "control" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "field has-addons header-field right red" }
const _hoisted_47 = { class: "control" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_50 = [
  _hoisted_49
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.currentPackage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                (_ctx.currentPackage)
                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 0,
                      class: "select is-small",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentViewKey = $event))
                    }, [
                      _hoisted_5,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentPackage.data.views, (view, viewKey) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: viewKey,
                          value: viewKey
                        }, _toDisplayString(viewKey), 9, _hoisted_6))
                      }), 128))
                    ], 512)), [
                      [_vModelSelect, _ctx.currentViewKey]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "button is-small",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addView()))
                }, _hoisted_9)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.currentViewKey)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                (_ctx.currentViewKey)
                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 0,
                      class: "select is-small",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentSpread = $event))
                    }, [
                      _hoisted_13,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentView.spreads, (spread, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: i,
                          value: spread
                        }, _toDisplayString(spread.name), 9, _hoisted_14))
                      }), 128))
                    ], 512)), [
                      [_vModelSelect, _ctx.currentSpread]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  class: "button is-small",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addSpread()))
                }, _hoisted_17)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  class: "button is-small",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.upSpread()))
                }, _hoisted_20)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", {
                  class: "button is-small",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.downSpread()))
                }, _hoisted_23)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("button", {
                  class: "button is-small",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.removeSpread()))
                }, _hoisted_26)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              class: "button is-small is-primary play-button",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.play())),
              disabled: !_ctx.currentSpread
            }, [
              (!_ctx.rendering)
                ? (_openBlock(), _createElementBlock("i", _hoisted_30))
                : (_openBlock(), _createElementBlock("i", _hoisted_31))
            ], 8, _hoisted_29)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("button", {
              class: "button is-small is-primary",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleLive())),
              disabled: !_ctx.currentSpread
            }, [
              (!_ctx.live)
                ? (_openBlock(), _createElementBlock("i", _hoisted_34))
                : (_openBlock(), _createElementBlock("i", _hoisted_35))
            ], 8, _hoisted_33)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _withDirectives(_createElementVNode("select", {
              class: "select is-small",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.internalPickedPreviewArgument = $event))
            }, [
              _hoisted_37,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentPackage.data.previewArguments, (previewArgument, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: i,
                  value: previewArgument
                }, _toDisplayString(previewArgument.name), 9, _hoisted_38))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.internalPickedPreviewArgument]
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _withDirectives(_createElementVNode("select", {
              class: "select is-small",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.internalLiveInterval = $event))
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([500, 1000, 2000, 5000, 10000], (liveInterval, i) => {
                return _createElementVNode("option", {
                  key: i,
                  value: liveInterval
                }, _toDisplayString(liveInterval / 1000) + "s ", 9, _hoisted_40)
              }), 64))
            ], 512), [
              [_vModelSelect, _ctx.internalLiveInterval]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("button", {
              class: "button is-small is-primary",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.save())),
              disabled: !_ctx.currentPackage
            }, _hoisted_45, 8, _hoisted_43)
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("button", {
              class: "button is-small is-primary",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.deleteProject())),
              disabled: !_ctx.currentPackage
            }, _hoisted_50, 8, _hoisted_48)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}